import React, { useEffect, useState, useRef } from 'react';
import { store } from '../../../lib/store'; // assuming you have a Redux store
import { connect } from 'react-redux';

let buildContent = (url, color) => {
    let colorMarker
    const hasSpaces = url && url.includes(' ');
    const imageUrl = hasSpaces ? url.replace(/\s/g, '%20') : url;
    if (color) {
        if (color.length <= 6 || color.length <= 7) {
            colorMarker = color[0] == '#' ? color : '#' + color;
        } else {
            colorMarker = color[0] == '#' ? color.substring(2) : '#' + color.substring(2);
        }
    } else {
        colorMarker = '#9ECC3B';
    }

    const content = document.createElement("div");
    content.innerHTML = `
        <svg class="default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <clipPath id="circleClip">
                    <circle cx="8" cy="6" r="5" />
                </clipPath>
            </defs>
            <rect width="16" height="16" id="icon-bound" fill="none"></rect>
            <path
                d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z"
                fill=${colorMarker}></path>
            <circle class="" cx="8" cy="6" r="5" fill="#FFFFFF"></circle>
            <image xlink:href=${imageUrl ? imageUrl : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'}
             x="4" y="1.5" width="7" height="9" clip-path="url(#circleClip)"></image>
        </svg>
        `;
    return content;
}

const updateItems = (currentItems, previousItems, setPreviousItems, type, buildContent) => {
    const newItemsMap = new Map();

    currentItems.forEach(item => {
        const itemId = item.id;
        const existingItem = previousItems.get(itemId);

        if (existingItem) {

            // MARKER / PHOTOMARKER
            if (type === 'marker' || type === 'photoMarker') {
                const prevLat = existingItem.lantitude;
                const prevLng = existingItem.longitute;
                const prevColor = existingItem.color;
                const prevIconUrl = existingItem.iconUrl;

                if (
                    prevLat !== item.lantitude ||
                    prevLng !== item.longitute ||
                    prevColor !== item.color ||
                    prevIconUrl !== item.iconUrl
                ) {
                    const mapObject = typeof item.mapObj === 'function' ? item.mapObj() : null;
                    if (mapObject) {
                        mapObject.position = { lat: item.lantitude, lng: item.longitute };
                        mapObject.content = buildContent(item.iconUrl, item.color);
                    }
                }
            }

            // POLYGON
            else if (type === 'polygon') {
                if (!item.geoJson) {
                    newItemsMap.set(itemId, item);
                    return;
                }

                const prevCoords = JSON.stringify(existingItem.coordinates);
                const newCoords = JSON.stringify(item.coordinates);
                const prevColor = existingItem.color;
                const prevGeoJson = existingItem.geoJson;

                if (prevCoords !== newCoords || prevColor !== item.color || prevGeoJson !== item.geoJson) {
                    const mapObject = item.mapObj();
                    if (mapObject && typeof mapObject.setPath === 'function' && item.coordinates?.length > 0) {
                        mapObject.setPath(item.coordinates);
                        mapObject.setOptions({ fillColor: item.color });
                    }
                }
            }

            // CIRCLE
            else if (type === 'circle') {
                if (!item.geoJson) {
                    newItemsMap.set(itemId, item);
                    return;
                }

                const prevCenter = JSON.stringify(existingItem.center);
                const newCenter = JSON.stringify(item.center);
                const prevRadius = existingItem.radius;
                const prevColor = existingItem.color;
                const prevGeoJson = existingItem.geoJson;

                if (
                    prevCenter !== newCenter ||
                    prevRadius !== item.radius ||
                    prevColor !== item.color ||
                    prevGeoJson !== item.geoJson
                ) {
                    const mapObject = typeof item.mapObj === 'function' ? item.mapObj() : null;
                    if (mapObject) {
                        mapObject.setCenter(item.center);
                        mapObject.setRadius(item.radius);
                        mapObject.setOptions({ fillColor: item.color });
                    }
                }
            }

            // LINE
            else if (type === 'line') {
                if (!item.geoJson) {
                    newItemsMap.set(itemId, item);
                    return;
                }

                let geoJsonData;
                try {
                    geoJsonData = JSON.parse(item.geoJson);
                } catch (e) {
                    console.error('Invalid geoJson for line:', item.id);
                    newItemsMap.set(itemId, item);
                    return;
                }

                const coordinates = geoJsonData.features[0].geometry.coordinates.map(
                    coord => ({ lat: coord[1], lng: coord[0] })
                );

                const prevPath = JSON.stringify(existingItem.path);
                const newPath = JSON.stringify(coordinates);
                const prevColor = existingItem.color;
                const newColor = geoJsonData.features[0].properties?.line?.color;
                const prevGeoJson = existingItem.geoJson;

                if (prevPath !== newPath || prevColor !== newColor || prevGeoJson !== item.geoJson) {
                    const mapObject = typeof item.mapObj === 'function' ? item.mapObj() : null;
                    if (mapObject) {
                        if (typeof mapObject.setPath === 'function' && coordinates?.length >= 2) {
                            // 2D Google Maps Polyline
                            mapObject.setPath(coordinates);
                            mapObject.setOptions({
                                strokeColor: newColor || '#000000',
                                strokeWeight: geoJsonData.features[0].properties?.line?.width || 2,
                            });
                        } else {
                            // 3D Polyline3DElement — path is a property, no setOptions
                            const coords3d = geoJsonData.features[0].geometry.coordinates.map(
                                coord => ({ lat: coord[1], lng: coord[0], altitude: 100 })
                            );
                            mapObject.path = coords3d;
                            if (newColor) mapObject.strokeColor = newColor;
                        }
                    }
                }
            }
        }

        // ✅ ALWAYS add item
        newItemsMap.set(itemId, item);
    });

    // REMOVE DELETED ITEMS
    previousItems.forEach((item, itemId) => {
        if (!newItemsMap.has(itemId)) {
            const mapObject = typeof item?.mapObj === 'function' ? item.mapObj() : item?.mapObj;
            if (mapObject) {
                if (typeof mapObject.setMap === 'function') {
                    mapObject.setMap(null);
                    mapObject.map = null;
                } else if (typeof mapObject.remove === 'function') {
                    // Polyline3DElement / other DOM-based 3D elements
                    mapObject.remove();
                }
            }
        }
    });

    setPreviousItems(newItemsMap);
};




// //optimized code 
// const updateItems = (currentItems, previousItems, setPreviousItems, type, buildContent) => {
//     const newItemsMap = new Map(); // New map to store updated items

//     currentItems.forEach(item => {
//         const itemId = item.id;
//         let existingItem = previousItems.get(itemId);

//         // Common logic for all types
//         if (!existingItem) {

//         } else {
//             if (!item.geoJson) {
//                 return; // skip this item safely
//             }
//             // Update existing items with type-specific logic
//             if (type === 'marker' || type === 'photoMarker') {
//                 const prevLat = existingItem.lantitude;
//                 const prevLng = existingItem.longitute;
//                 const prevColor = existingItem.color;
//                 const prevIconUrl = existingItem.iconUrl;

//                 if (prevLat !== item.lantitude || prevLng !== item.longitute || prevColor !== item.color || prevIconUrl !== item.iconUrl) {
//                     let mapObject = item.mapObj();
//                     mapObject.position = { lat: item.lantitude, lng: item.longitute };
//                     mapObject.content = buildContent(item.iconUrl, item.color);
//                 }
//             } else if (type === 'polygon') {
//                 if (!item.geoJson) {
//                     return; // skip this item safely
//                 }
//                 const prevCoords = JSON.stringify(existingItem.coordinates);
//                 const newCoords = JSON.stringify(item.coordinates);
//                 const prevColor = existingItem.color;
//                 const newColor = item.color;
//                 const prevGeoJson = existingItem.geoJson;
//                 const newGeoJson = item.geoJson;
//                 if (prevCoords !== newCoords || prevColor !== newColor || prevGeoJson !== newGeoJson) {
//                     let mapObject = item.mapObj();
//                     mapObject.setPath(item.coordinates);
//                     mapObject.setOptions({ fillColor: item.color });
//                 }
//             } else if (type === 'circle') {

//                 const prevCenter = JSON.stringify(existingItem.center);
//                 const newCenter = JSON.stringify(item.center);
//                 const prevRadius = existingItem.radius;
//                 const newRadius = item.radius;
//                 const prevColor = existingItem.color;
//                 const newColor = item.color;
//                 const prevGeoJson = existingItem.geoJson;
//                 const newGeoJson = item.geoJson;

//                 if (prevCenter !== newCenter || prevRadius !== newRadius || prevColor !== newColor || prevGeoJson !== newGeoJson) {

//                     let mapObject = item.mapObj();
//                     mapObject.setCenter(item.center);
//                     mapObject.setRadius(item.radius);
//                     mapObject.setOptions({ fillColor: item.color });
//                 }
//             } else if (type === 'line') {
//                 const prevPath = JSON.stringify(existingItem.path);
//                 const geoJsonData = JSON.parse(item.geoJson);
//                 let coordinates = geoJsonData.features[0].geometry.coordinates.map(coord => ({ lat: coord[1], lng: coord[0] }));
//                 const newPath = JSON.stringify(coordinates);
//                 const prevColor = existingItem.color;
//                 const newColor = geoJsonData.features[0].properties.line.color;
//                 const prevGeoJson = existingItem.geoJson;
//                 const newGeoJson = item.geoJson;

//                 if (prevPath !== newPath || prevColor !== newColor || prevGeoJson !== newGeoJson) {
//                     const mapObject = item?.mapObj();
//                     if (mapObject && typeof mapObject.setPath === 'function') {
//                         mapObject.setPath(coordinates);
//                     }

//                     if (mapObject && typeof mapObject.setOptions === 'function') {
//                         mapObject.setOptions({
//                             strokeColor: geoJsonData?.features?.[0]?.properties?.line?.color || '#000000',
//                             strokeWeight: geoJsonData?.features?.[0]?.properties?.line?.width || 2,
//                         });
//                     }
//                 }

//             }
//         }

//         newItemsMap.set(itemId, item);
//     });

//     // Remove items that no longer exist
//     previousItems.forEach((item, itemId) => {
//         if (!newItemsMap.has(itemId)) {
//             if (item.mapObj()) {
//                 item.mapObj().setMap(null); // Remove from map
//             }
//             // Special case for 'photoMarker' type (ensure mapObj is removed)
//             if ((type === 'photoMarker' || type === 'marker') && item.mapObj()) {
//                 item.mapObj().map = null; // Explicitly set the map to null for photoMarker
//             }
//         }
//     });

//     // Update the previous items state
//     setPreviousItems(newItemsMap);
// };

const MapMarkersUpdater = (props) => {
    const [previousMarkers, setPreviousMarkers] = useState(new Map());
    const [previousPhotoMarkers, setPreviousPhotoMarkers] = useState(new Map());
    const [previousPolygons, setPreviousPolygons] = useState(new Map());
    const [previousCircles, setPreviousCircles] = useState(new Map());
    const [previousLines, setPreviousLines] = useState(new Map());

    // Snapshot updated on every render so the interval callback always reads
    // current props/state without re-creating (and thus re-scheduling) the interval.
    const latestRef = useRef({});
    latestRef.current = {
        props,
        previousMarkers,
        previousPhotoMarkers,
        previousPolygons,
        previousCircles,
        previousLines,
    };

    useEffect(() => {
        const intervalId = setInterval(() => {
            const { props: p, previousMarkers: pm, previousPhotoMarkers: ppm,
                    previousPolygons: pp, previousCircles: pc, previousLines: pl } = latestRef.current;
            p.fetchChanges();
            updateItems(p.markers, pm, setPreviousMarkers, 'marker', buildContent);
            updateItems(p.photos, ppm, setPreviousPhotoMarkers, 'photoMarker', buildContent);
            updateItems(p.polygons, pp, setPreviousPolygons, 'polygon', buildContent);
            updateItems(p.circles, pc, setPreviousCircles, 'circle', buildContent);
            updateItems(p.lines, pl, setPreviousLines, 'line', buildContent);
        }, 1000 * 60 * 2.5);

        return () => clearInterval(intervalId);
    }, []); // Empty — interval is created once and never reset by state/prop changes

    return null;
};

const mapStateToProps = (state) => ({
    markers: state.markers,
    photos: state.photos,
    circles: state.circles,
    lines: state.lines,
    polygons: state.polygons,
});

export default connect(mapStateToProps)(MapMarkersUpdater);
